<template>
  <div class="bg-background-light dark:bg-background-dark font-sans text-[#0d121b] antialiased">
    <AppHeader />
    <div class="w-full bg-white dark:bg-[#1a202c]">
      <div class="max-w-[1280px] mx-auto px-4 lg:px-10 py-6 lg:py-8">
        <div class="flex flex-col justify-end overflow-hidden rounded-xl min-h-[200px] lg:min-h-[280px] relative" 
             data-alt="Hubei construction labor association general assembly group photo banner">
          <div class="absolute inset-0 bg-cover bg-center transition-all duration-1000"
               :class="imageLoadedMap['banner'] ? 'blur-0 scale-100' : 'blur-2xl scale-110 opacity-50'"
               style='background-image: linear-gradient(0deg, rgba(15, 23, 42, 0.55) 0%, rgba(15, 23, 42, 0.15) 100%), url("/images/banner/association_overview_banner.png");'>
          </div>
          <img src="/images/banner/association_overview_banner.png" class="hidden" @load="onImageLoad('banner')" />
          <div class="absolute inset-0 bg-black/20 z-10"></div>
          <div class="flex flex-col p-6 lg:p-10 relative z-20">
            <h1 class="text-white tracking-tight text-3xl lg:text-4xl font-bold leading-tight mb-2">协会概况</h1>
            <p class="text-white/90 text-base lg:text-lg font-medium">服务湖北建筑工人，维护职工合法权益，推动行业高质量发展</p>
          </div>
        </div>
      </div>
    </div>
    <div class="max-w-[1280px] mx-auto px-4 lg:px-10 py-12">
      <div class="flex flex-col lg:grid lg:grid-cols-12 gap-8 lg:gap-12 relative">
        <aside class="lg:col-span-3">
          <div class="lg:sticky lg:top-24 space-y-4">
            <div class="bg-white rounded-xl shadow-sm border border-[#e7ebf3] overflow-hidden">
              <div class="p-4 border-b border-[#e7ebf3] bg-[#f8f9fc]">
                <h3 class="text-[#0d121b] text-base font-bold">概况导航</h3>
              </div>
              <nav class="flex lg:flex-col overflow-x-auto lg:overflow-visible p-2 gap-1 hide-scrollbar">
                <a class="flex-shrink-0 lg:flex-shrink w-auto lg:w-full flex items-center gap-3 px-4 py-3 rounded-lg bg-primary text-white transition-all group" href="#intro" @click.prevent="scrollToSection('intro')">
                  <span class="material-symbols-outlined text-[20px]">corporate_fare</span>
                  <span class="text-sm font-medium">协会简介</span>
                </a>
                <a class="flex-shrink-0 lg:flex-shrink w-auto lg:w-full flex items-center gap-3 px-4 py-3 rounded-lg text-[#0d121b] hover:bg-[#e7ebf3] hover:text-primary transition-all group" href="#history" @click.prevent="scrollToSection('history')">
                  <span class="material-symbols-outlined text-[20px] text-[#9ca3af] group-hover:text-primary">history_edu</span>
                  <span class="text-sm font-medium">发展历程</span>
                </a>
                <a class="flex-shrink-0 lg:flex-shrink w-auto lg:w-full flex items-center gap-3 px-4 py-3 rounded-lg text-[#0d121b] hover:bg-[#e7ebf3] hover:text-primary transition-all group" href="#structure" @click.prevent="scrollToSection('structure')">
                  <span class="material-symbols-outlined text-[20px] text-[#9ca3af] group-hover:text-primary">account_tree</span>
                  <span class="text-sm font-medium">组织架构</span>
                </a>
                <a class="flex-shrink-0 lg:flex-shrink w-auto lg:w-full flex items-center gap-3 px-4 py-3 rounded-lg text-[#0d121b] hover:bg-[#e7ebf3] hover:text-primary transition-all group" href="#leadership" @click.prevent="scrollToSection('leadership')">
                  <span class="material-symbols-outlined text-[20px] text-[#9ca3af] group-hover:text-primary">groups</span>
                  <span class="text-sm font-medium">领导风采</span>
                </a>
                <a class="flex-shrink-0 lg:flex-shrink w-auto lg:w-full flex items-center gap-3 px-4 py-3 rounded-lg text-[#0d121b] hover:bg-[#e7ebf3] hover:text-primary transition-all group" href="#objectives" @click.prevent="scrollToSection('objectives')">
                  <span class="material-symbols-outlined text-[20px] text-[#9ca3af] group-hover:text-primary">flag</span>
                  <span class="text-sm font-medium">宗旨与目标</span>
                </a>
                <a class="flex-shrink-0 lg:flex-shrink w-auto lg:w-full flex items-center gap-3 px-4 py-3 rounded-lg text-[#0d121b] hover:bg-[#e7ebf3] hover:text-primary transition-all group" href="#achievements" @click.prevent="scrollToSection('achievements')">
                  <span class="material-symbols-outlined text-[20px] text-[#9ca3af] group-hover:text-primary">emoji_events</span>
                  <span class="text-sm font-medium">荣誉成就</span>
                </a>
              </nav>
            </div>
            <div class="hidden lg:block bg-gradient-to-br from-primary to-[#0a40b0] rounded-xl p-6 text-white shadow-lg">
              <span class="material-symbols-outlined text-4xl mb-4 opacity-80">support_agent</span>
              <h4 class="font-bold text-lg mb-2">需要帮助?</h4>
              <p class="text-white/80 text-sm mb-4">如果您有任何疑问或需要咨询，请随时联系我们的秘书处。</p>
              <div class="text-sm font-mono opacity-90">027-84881278</div>
              <div class="text-sm font-mono opacity-90">hbsjzlwxh@163.com</div>
            </div>
          </div>
        </aside>
        <main class="lg:col-span-9 space-y-12">
          <section class="bg-white rounded-xl p-6 lg:p-8 shadow-sm border border-[#e7ebf3] scroll-mt-28" id="intro">
            <div class="flex items-center gap-3 mb-6">
              <div class="w-1.5 h-8 bg-primary rounded-full"></div>
              <h2 class="text-2xl font-bold text-[#0d121b]">协会简介</h2>
            </div>
            <div class="block">
              <div class="w-full lg:w-1/3 lg:float-right lg:ml-8 mb-6 relative overflow-hidden rounded-lg shadow-md aspect-[4/3] bg-slate-50/50 flex items-center justify-center p-2 border border-slate-100">
                <img alt="全国四好商会荣誉奖牌" 
                     class="w-full h-full object-contain transition-all duration-1000 rounded" 
                     :class="imageLoadedMap['intro'] ? 'blur-0 scale-100 opacity-100' : 'blur-xl scale-110 opacity-50'"
                     src="/images/about_intro.jpg"
                     @load="onImageLoad('intro')"/>
              </div>
              <div class="text-[#4c669a] leading-relaxed space-y-4 text-justify">
                <p>
                  <strong>湖北省建筑劳务协会</strong>（下简称：协会）是由从事建筑劳务行业的企业自愿发起，经湖北省民政厅批准成立的全省性、行业性、非盈利性社会团体。湖北省建筑劳务协会于2018年8月9日正式登记成立，在往届领导班子的带领下，在会员单位的参与和支持下，目前已发展有429家建筑劳务会员单位。
                </p>
                <p>
                  湖北省建筑劳务协会本着“助力会员发展，解难会员痛点，赋能会员价值，共创行业辉煌”为宗旨，坚持以“服务、团结、互助、自律、进取、奉献”的办会理念，聚合本省长期从事建筑劳务企业、相关专家和专业服务机构等综合力量，依托本会平台及功能服务，促进湖北建筑劳务行业健康发展。
                </p>
                <div class="bg-blue-50/50 p-4 rounded-lg border border-blue-100 space-y-2 text-sm mt-4">
                  <p><strong>协会愿景：</strong>共建行业平台，打造全国建筑劳务服务第一社团。</p>
                  <p><strong>协会使命：</strong>助力会员发展，解难会员痛点，赋能会员价值，共创行业辉煌。</p>
                  <p><strong>协会价值观：</strong>服务、团结、互助、自律、进取、奉献</p>
                  <p><strong>办会的四种精神：</strong>甘为人梯的互助精神；乐于奉献的无私精神；助人为乐的公益精神；勇于负责的担当精神。</p>
                  <p><strong>协会准则数字歌：</strong>一个宗旨，二个坚持，三个规范，四个对待，五个正确，六个维护，七个坚信，八个自信。</p>
                </div>
                <div class="mt-10 p-8 rounded-2xl bg-gradient-to-br from-blue-50 to-indigo-50/30 border border-blue-100/50 relative overflow-hidden group">
                  <div class="absolute -right-4 -top-4 size-24 bg-primary/5 rounded-full blur-2xl group-hover:bg-primary/10 transition-colors"></div>
                  <div class="relative z-10 flex flex-col items-center text-center">
                    <span class="material-symbols-outlined text-primary/40 text-4xl mb-4">format_quote</span>
                    <h3 class="text-xl lg:text-2xl font-black text-primary tracking-widest mb-3 uppercase">弘扬工匠精神，助推行业发展!</h3>
                    <div class="h-1 w-12 bg-gradient-to-r from-primary to-transparent rounded-full mb-4"></div>
                    <p class="text-lg font-bold text-[#1e40af] opacity-90 tracking-wider">—— 为建筑劳务保驾护航! ——</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="scroll-mt-28" id="history">
            <div class="flex items-center gap-3 mb-6">
              <div class="w-1.5 h-8 bg-primary rounded-full"></div>
              <h2 class="text-2xl font-bold text-[#0d121b]">发展历程</h2>
            </div>
            <div class="relative pl-6 lg:pl-10 space-y-12 py-2">
              <!-- Vertical Timeline Line with Gradient -->
              <div class="absolute left-[7px] lg:left-[11px] top-0 bottom-0 w-0.5 bg-gradient-to-b from-primary via-primary/50 to-transparent"></div>

              <!-- 2025 -->
              <div class="relative group">
                <div class="absolute -left-[23px] lg:-left-[35px] top-1.5 size-4 rounded-full border-4 border-white bg-primary shadow-[0_0_15px_rgba(30,64,175,0.4)] group-hover:scale-125 transition-transform duration-500 z-10"></div>
                <div class="flex flex-col sm:flex-row gap-2 sm:gap-10 items-start">
                  <div class="flex flex-col min-w-[100px]">
                    <span class="text-primary font-black text-2xl tracking-tighter">2025</span>
                  </div>
                  <div class="bg-white p-6 rounded-2xl border border-slate-100 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] flex-1 hover:shadow-xl hover:border-primary/20 transition-all duration-500 relative overflow-hidden group-hover:-translate-y-1">
                    <div class="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full -mr-16 -mt-16 blur-3xl group-hover:bg-primary/10 transition-colors"></div>
                    <h4 class="font-black text-slate-800 text-lg mb-2 relative z-10">党建实体化转型与规模跨越</h4>
                    <p class="text-slate-500 text-sm leading-relaxed relative z-10">党组织顺利换届，推动党建从“功能型”转为“实体型”党支部。在王知兵会长领导下，对外联络部、麻城办事处相继成立，组织平台建设迎来新突破，协会迈入高质量发展快车道。</p>
                  </div>
                </div>
              </div>
              
              <!-- 2024 -->
              <div class="relative group">
                <div class="absolute -left-[23px] lg:-left-[35px] top-1.5 size-4 rounded-full border-4 border-white bg-slate-300 group-hover:bg-primary transition-colors duration-500 z-10 shadow-sm"></div>
                <div class="flex flex-col sm:flex-row gap-2 sm:gap-10 items-start">
                  <span class="text-slate-300 font-black text-2xl tracking-tighter group-hover:text-primary transition-colors duration-500 min-w-[100px]">2024</span>
                  <div class="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm flex-1 hover:shadow-xl hover:border-primary/20 transition-all duration-500 group-hover:-translate-y-1">
                    <h4 class="font-bold text-slate-800 text-lg mb-2">从“新”出发·走上新征途</h4>
                    <p class="text-slate-500 text-sm leading-relaxed">2024年2月29日举行第二届会员大会，诞生新一届领导班子。确立以王知兵会长为核心的管理团队，完善组织架构与制度流程，坚持服务创新，推动协会迈向新台阶。</p>
                  </div>
                </div>
              </div>

              <!-- 2023 -->
              <div class="relative group">
                <div class="absolute -left-[23px] lg:-left-[35px] top-1.5 size-4 rounded-full border-4 border-white bg-slate-300 group-hover:bg-primary transition-colors duration-500 z-10 shadow-sm"></div>
                <div class="flex flex-col sm:flex-row gap-2 sm:gap-10 items-start">
                  <span class="text-slate-300 font-black text-2xl tracking-tighter group-hover:text-primary transition-colors duration-500 min-w-[100px]">2023</span>
                  <div class="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm flex-1 hover:shadow-xl hover:border-primary/20 transition-all duration-500 group-hover:-translate-y-1">
                    <h4 class="font-bold text-slate-800 text-lg mb-2">求生存·谋发展</h4>
                    <p class="text-slate-500 text-sm leading-relaxed">面对行业严峻形势，响应政府号召，将拯救与自救相结合。总结首个五年的得与失，传承优良办会文化与精神，党支部再次获评“优秀基层党组织”。</p>
                  </div>
                </div>
              </div>

              <!-- 2018-2022 remains similarly styled -->
              <div v-for="(item, idx) in [
                {year: '2022', title: '对标“四好”·殊荣加冕', content: '获评全国“四好”建设达标先进单位；调解委获评先进单位。赵书均会长当选省工商联执委。引导会员企业转型升级。'},
                {year: '2021', title: '换届选举·振兴行业', content: '2021年4月22日召开第五次会员大会，选举赵书均担任第一届第二任会长。党支部被评为“优秀基层党组织”。'},
                {year: '2020', title: '同心抗疫·社会责任', content: '2020年6月被省工商联评为“抗击新冠肺炎积极贡献单位”，在特殊时期积极参与公益捐赠。'},
                {year: '2019', title: '规模扩展·步入正轨', content: '会员突破400家，职能制度逐步完善。'},
                {year: '2018', title: '扬帆启航·协会成立', content: '2018年8月9日正式成立；确立专委会制度。'}
              ]" :key="idx" class="relative group">
                <div class="absolute -left-[23px] lg:-left-[35px] top-1.5 size-4 rounded-full border-4 border-white bg-slate-300 group-hover:bg-primary transition-colors duration-500 z-10 shadow-sm"></div>
                <div class="flex flex-col sm:flex-row gap-2 sm:gap-10 items-start">
                  <span class="text-slate-300 font-black text-2xl tracking-tighter group-hover:text-primary transition-colors duration-500 min-w-[100px]">{{ item.year }}</span>
                  <div class="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm flex-1 hover:shadow-xl hover:border-primary/20 transition-all duration-500 group-hover:-translate-y-1">
                    <h4 class="font-bold text-slate-800 text-lg mb-2">{{ item.title }}</h4>
                    <p class="text-slate-500 text-sm leading-relaxed">{{ item.content }}</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="scroll-mt-28" id="structure">
            <div class="flex items-center gap-3 mb-6">
              <div class="w-1.5 h-8 bg-primary rounded-full"></div>
              <h2 class="text-2xl font-bold text-[#0d121b]">组织架构</h2>
            </div>
            <div class="bg-[#f8fafc] dark:bg-[#1a202c] p-6 lg:p-12 rounded-2xl shadow-inner border border-[#e7ebf3] dark:border-gray-700 overflow-hidden relative">
              <!-- Background Decorative Grid -->
              <div class="absolute inset-0 opacity-[0.03] pointer-events-none" style="background-image: radial-gradient(#1e40af 1px, transparent 1px); background-size: 24px 24px;"></div>

              <div class="w-full flex flex-col items-center py-8 relative z-10 scale-[0.85] lg:scale-100 origin-top transform-gpu transition-transform">
                <!-- Level 1: General Assembly -->
                <div class="relative flex flex-col items-center group">
                  <div class="bg-gradient-to-br from-[#1e40af] to-[#1e3a8a] text-white px-12 py-4 rounded-2xl font-black text-xl shadow-[0_10px_40px_-10px_rgba(30,64,175,0.5)] border border-white/20 transform group-hover:scale-105 group-hover:shadow-primary/40 transition-all duration-500 cursor-default">
                    会员(代表)大会
                  </div>
                  <!-- Main Vertical Line -->
                  <div class="h-12 w-0.5 bg-gradient-to-b from-[#1e40af] to-[#2563eb]"></div>
                </div>

                <!-- Level 2 Connector Branch -->
                <div class="relative w-full h-12">
                  <div class="absolute top-0 left-1/2 -translate-x-1/2 w-[480px] h-0.5 bg-[#2563eb]">
                    <!-- Left branch to Council -->
                    <div class="absolute top-0 left-0 h-12 w-0.5 bg-[#2563eb]">
                      <div class="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[8px] border-t-[#2563eb]"></div>
                    </div>
                    <!-- Right branch to Supervisory -->
                    <div class="absolute top-0 right-0 h-12 w-0.5 bg-[#2563eb]">
                      <div class="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[8px] border-t-[#2563eb]"></div>
                    </div>
                    <!-- Center vertical line (Starts from dotted line, ends with arrow at box) -->
                    <div class="absolute top-[76px] left-1/2 -translate-x-1/2 h-[80px] w-0.5 bg-gradient-to-b from-[#2563eb] to-[#1e40af] z-0">
                       <div class="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[8px] border-t-[#1e40af]"></div>
                    </div>
                  </div>
                </div>

                <!-- Level 2: Council & Supervisory -->
                <div class="relative w-full flex justify-center items-center gap-[300px] mb-14">
                  <div class="absolute top-1/2 left-[35%] right-[35%] h-px border-t-2 border-dotted border-blue-200 dark:border-blue-800 -translate-y-1/2 -z-0"></div>
                  
                  <div class="w-[180px] bg-white/80 dark:bg-gray-800/80 backdrop-blur-md text-[#1e40af] dark:text-blue-400 py-4 rounded-2xl font-bold shadow-xl border border-white/50 dark:border-gray-700 hover:border-primary hover:shadow-primary/10 transition-all duration-500 cursor-default z-10 text-center group">
                    理事会
                    <div class="absolute -top-2 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[8px] border-t-[#2563eb] opacity-0 group-hover:opacity-100 transition-opacity"></div>
                  </div>
                  <div class="w-[180px] bg-white/80 dark:bg-gray-800/80 backdrop-blur-md text-[#1e40af] dark:text-blue-400 py-4 rounded-2xl font-bold shadow-xl border border-white/50 dark:border-gray-700 hover:border-primary hover:shadow-primary/10 transition-all duration-500 cursor-default z-10 text-center group">
                    监事会
                    <div class="absolute -top-2 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[8px] border-t-[#2563eb] opacity-0 group-hover:opacity-100 transition-opacity"></div>
                  </div>
                </div>

                <!-- Level 3: President's Office -->
                <div class="relative flex flex-col items-center group">
                   <div class="bg-gradient-to-br from-[#2563eb] to-[#1e40af] text-white px-12 py-4 rounded-2xl font-black text-lg shadow-2xl border border-white/20 transform group-hover:scale-105 transition-all duration-500">
                     会长办公室
                   </div>
                   <div class="h-12 w-0.5 bg-gradient-to-b from-[#1e40af] to-[#3b82f6]"></div>
                </div>

                <!-- Level 4: Committees & Secretariat -->
                <div class="relative w-full flex flex-col items-center">
                  <div class="relative w-full max-w-5xl flex justify-center items-start h-12">
                    <div class="absolute top-0 left-1/2 -translate-x-1/2 w-[412px] h-0.5 bg-[#3b82f6]">
                      <div class="absolute top-0 left-0 h-12 w-0.5 bg-[#3b82f6]"></div>
                      <div class="absolute top-0 left-1/2 -translate-x-1/2 h-12 w-0.5 bg-[#3b82f6]"></div>
                      <div class="absolute top-0 right-0 h-12 w-0.5 bg-[#3b82f6]"></div>
                    </div>
                  </div>

                  <div class="flex justify-center items-start gap-4 w-full max-w-5xl mb-12">
                    <div class="w-[180px] flex flex-col items-center">
                      <div class="bg-white/90 dark:bg-gray-800 text-slate-700 dark:text-gray-300 px-4 py-4 rounded-2xl font-bold text-sm shadow-lg border border-slate-100 dark:border-gray-700 text-center w-full relative hover:border-primary/40 hover:shadow-xl transition-all duration-500 group">
                        专家顾问委员会
                        <div class="absolute -top-2 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[5px] border-l-transparent border-r-[5px] border-r-transparent border-t-[7px] border-t-[#3b82f6]"></div>
                      </div>
                    </div>

                    <div class="w-[200px] flex flex-col items-center">
                      <div class="bg-gradient-to-b from-[#1e40af] to-[#1e3a8a] text-white px-8 py-5 rounded-2xl font-black text-lg shadow-2xl border border-white/10 ring-8 ring-blue-50/50 dark:ring-blue-900/10 relative transform hover:scale-110 transition-all duration-500 group cursor-default">
                        秘书处
                        <div class="absolute -top-2 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[5px] border-l-transparent border-r-[5px] border-r-transparent border-t-[7px] border-t-[#3b82f6]"></div>
                      </div>
                    </div>

                    <div class="w-[180px] flex flex-col items-center">
                      <div class="bg-white/90 dark:bg-gray-800 text-slate-700 dark:text-gray-300 px-4 py-4 rounded-2xl font-bold text-sm shadow-lg border border-slate-100 dark:border-gray-700 text-center w-full relative hover:border-primary/40 hover:shadow-xl transition-all duration-500 group">
                        人民调解委员会
                        <div class="absolute -top-2 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[5px] border-l-transparent border-r-[5px] border-r-transparent border-t-[7px] border-t-[#3b82f6]"></div>
                      </div>
                    </div>
                  </div>

                  <div class="relative w-full flex flex-col items-center">
                    <div class="h-12 w-0.5 bg-gradient-to-b from-[#1e3a8a] to-[#3b82f6] relative">
                      <div class="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[5px] border-l-transparent border-r-[5px] border-r-transparent border-t-[7px] border-t-[#3b82f6]"></div>
                    </div>
                    
                    <div class="relative w-full max-w-[1100px] mt-4 px-4">
                      <div class="absolute top-0 left-[5%] right-[5%] h-px bg-gradient-to-r from-transparent via-[#3b82f6] to-transparent"></div>
                      
                      <div class="flex justify-between items-start pt-0">
                        <div v-for="(dept, idx) in ['会员部', '办公室', '对外联络部', '劳务总包专委会', '钢筋专委会', '木工专委会', '泥工专委会', '综合专委会', '孝感办事处', '麻城办事处']" :key="dept" class="flex flex-col items-center flex-1 group">
                          <div class="h-8 w-px bg-slate-200 group-hover:bg-primary transition-colors"></div>
                          <div class="relative w-full flex justify-center px-2">
                            <div 
                              class="relative bg-white dark:bg-gray-800 text-slate-600 dark:text-gray-400 py-8 px-4 rounded-3xl font-black text-[11px] md:text-sm shadow-[0_4px_12px_rgba(0,0,0,0.03)] border border-slate-50 dark:border-gray-700 [writing-mode:vertical-rl] h-40 md:h-52 flex items-center justify-center tracking-[0.4em] leading-relaxed group-hover:text-primary group-hover:border-primary/30 group-hover:shadow-2xl group-hover:shadow-primary/10 transition-all duration-700 w-full overflow-hidden"
                              :class="idx >= 8 ? 'bg-gradient-to-b from-indigo-50/50 to-white text-indigo-700 border-indigo-100 shadow-indigo-50' : ''"
                            >
                              <span class="relative z-10">{{ dept }}</span>
                              <div class="absolute inset-0 bg-primary/0 group-hover:bg-primary/[0.03] transition-colors"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>


          <section class="scroll-mt-28" id="leadership">
            <div class="flex items-center gap-3 mb-8">
              <div class="w-1.5 h-8 bg-primary rounded-full"></div>
              <h2 class="text-2xl font-bold text-[#0d121b]">领导风采</h2>
            </div>


            <div class="space-y-12">
              <!-- Association Main Leaders -->
              <div class="space-y-16">
                <!-- 会长 (Centered with premium treatment) -->
                <div class="flex flex-col items-center">
                  <div class="group relative flex flex-col items-center bg-white dark:bg-gray-800/80 backdrop-blur-xl rounded-[2.5rem] overflow-hidden shadow-[0_20px_60px_-15px_rgba(0,0,0,0.1)] border border-white/50 dark:border-gray-700 hover:shadow-2xl hover:shadow-primary/20 hover:-translate-y-2 transition-all duration-700 w-full max-w-[320px] p-4">
                    <div class="w-full aspect-[3/4] overflow-hidden rounded-[2rem] bg-slate-50 relative transition-all duration-1000"
                         :class="imageLoadedMap[leaders[0].id] ? 'blur-0 scale-100' : 'blur-2xl scale-110 opacity-50'">
                      <img :alt="leaders[0].name" class="w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-110" :src="getLeaderPhoto(leaders[0].img)" @load="onImageLoad(leaders[0].id)"/>
                      <div class="absolute inset-0 bg-gradient-to-t from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                    </div>
                    <div class="pt-6 pb-4 text-center w-full">
                      <h3 class="text-2xl font-black text-[#0d121b] dark:text-white mb-2 group-hover:text-primary transition-colors">{{ leaders[0].name }}</h3>
                      <div class="inline-block px-4 py-1 rounded-full bg-primary/10 text-primary text-xs font-bold tracking-wider">{{ leaders[0].title }}</div>
                    </div>
                  </div>
                </div>

                <!-- 其他领导 Grid -->
                <div class="max-w-7xl mx-auto">
                  <div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-8">
                    <div 
                      v-for="(item, index) in leaders.slice(1)" 
                      :key="index"
                      class="group relative flex flex-col items-center bg-white/60 dark:bg-gray-800/60 backdrop-blur-md rounded-3xl overflow-hidden shadow-lg border border-white/40 dark:border-gray-700 hover:shadow-2xl hover:-translate-y-2 transition-all duration-500 p-3"
                    >
                      <div class="w-full aspect-[3/4] overflow-hidden rounded-2xl bg-slate-50 relative transition-all duration-1000"
                           :class="imageLoadedMap[item.id] ? 'blur-0 scale-100' : 'blur-2xl scale-110 opacity-50'">
                        <img :alt="item.name" class="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110" :src="getLeaderPhoto(item.img)" @load="onImageLoad(item.id)"/>
                        <div class="absolute inset-0 bg-gradient-to-b from-transparent to-primary/5 opacity-0 group-hover:opacity-100 transition-opacity"></div>
                      </div>
                      <div class="pt-4 pb-2 text-center w-full">
                        <h3 class="text-lg font-bold text-[#0d121b] dark:text-white mb-1 group-hover:text-primary transition-colors">{{ item.name }}</h3>
                        <p class="text-[10px] text-slate-400 font-medium leading-tight px-2 h-8 flex items-center justify-center">{{ item.title }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </section>

          <section class="scroll-mt-28" id="objectives">
            <div class="flex items-center gap-3 mb-6">
              <div class="w-1.5 h-8 bg-primary rounded-full"></div>
              <h2 class="text-2xl font-bold text-[#0d121b]">宗旨与目标</h2>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div v-for="obj in [
                {icon: 'hub', title: '促进资源整合', desc: '集聚优质劳务资源，搭建行业供需对接平台。'},
                {icon: 'gavel', title: '促进行业规范', desc: '推进劳务队伍专业化、标准化、信用化建设。'},
                {icon: 'trending_up', title: '赋能发展', desc: '提升会员经营能力，引领行业高质量发展。'}
              ]" :key="obj.title" class="group bg-white dark:bg-gray-800 p-8 rounded-[2rem] border border-slate-100 dark:border-gray-700 shadow-[0_4px_25px_rgba(0,0,0,0.02)] hover:shadow-2xl hover:shadow-primary/5 hover:-translate-y-2 transition-all duration-500">
                <div class="size-16 rounded-2xl bg-primary/5 flex items-center justify-center text-primary mb-6 group-hover:bg-primary group-hover:text-white transition-all duration-500">
                  <span class="material-symbols-outlined text-4xl">{{ obj.icon }}</span>
                </div>
                <h3 class="text-xl font-bold text-[#0d121b] dark:text-white mb-4">{{ obj.title }}</h3>
                <p class="text-slate-500 dark:text-slate-400 text-sm leading-relaxed">
                  {{ obj.desc }}
                </p>
              </div>
            </div>
          </section>

          <section class="scroll-mt-28" id="achievements">
            <div class="flex items-center gap-3 mb-6">
              <div class="w-1.5 h-8 bg-primary rounded-full"></div>
              <h2 class="text-2xl font-bold text-[#0d121b]">荣誉成就</h2>
            </div>
            <div class="bg-gradient-to-br from-slate-50 to-white dark:from-gray-900 dark:to-gray-800 p-8 md:p-12 rounded-[2.5rem] border border-slate-100 dark:border-gray-700 shadow-inner overflow-hidden relative">
              <div class="absolute -top-24 -right-24 size-96 bg-primary/5 rounded-full blur-3xl pointer-events-none"></div>
              <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 relative z-10">
                <div v-for="award in [
                  {year: '2020', title: '湖北抗击新冠肺炎疫情积极贡献单位', org: '湖北省工商联颁发', icon: 'volunteer_activism'},
                  {year: '2022', title: '全国“四好”商会', org: '中华全国工商业联合会颁发', icon: 'military_tech'},
                  {year: '2022', title: '人民调解工作先进单位', org: '湖北省工商联颁发', icon: 'handshake'},
                  {year: '2023', title: '先进基层党组织', org: '湖北省工商联所属商会委员会颁发', icon: 'verified_user'},
                  {year: '2023', title: '湖北省金牌协调劳动关系社会组织', org: '三方委员会颁发', icon: 'workspace_premium'},
                  {year: '2025', title: '3A级社会组织', org: '湖北省民政厅颁发', icon: 'star'}
                ]" :key="award.title" class="group bg-white dark:bg-gray-800 p-5 rounded-[1.25rem] border border-slate-50 dark:border-gray-700 shadow-[0_4px_20px_rgba(0,0,0,0.03)] hover:shadow-2xl hover:border-primary/30 transition-all duration-500">
                  <div class="flex items-center gap-5">
                    <div class="size-14 shrink-0 rounded-xl bg-amber-50 dark:bg-amber-900/20 flex items-center justify-center text-amber-600 group-hover:bg-primary group-hover:text-white transition-all duration-500">
                      <span class="material-symbols-outlined text-2xl">{{ award.icon }}</span>
                    </div>
                    <div class="flex-1">
                      <div class="inline-block px-2 py-0.5 rounded bg-blue-50 text-primary text-[10px] font-black mb-1.5">{{ award.year }}</div>
                      <h4 class="font-black text-[#0d121b] dark:text-white text-base leading-snug group-hover:text-primary transition-colors">{{ award.title }}</h4>
                      <p class="text-xs text-slate-400 font-medium mt-1">{{ award.org }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>
    <footer class="bg-white border-t border-[#e7ebf3] py-12 mt-12">
      <div class="max-w-[1280px] mx-auto px-4 lg:px-10">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div class="col-span-1 md:col-span-2">
            <div class="flex items-center gap-3 text-[#0d121b] mb-4">
              <img alt="Logo" class="w-8 h-8 object-contain" src="/logo.png"/>
              <h2 class="text-lg font-bold">湖北省建筑劳务协会</h2>
            </div>
            <p class="text-[#4c669a] text-sm leading-relaxed max-w-sm mb-6">
              弘扬工匠精神，助推行业发展!<br/>
              ——为建筑劳务保驾护航!
            </p>
            <div class="flex gap-4">
              <a class="size-8 rounded-full bg-[#f8f9fc] flex items-center justify-center text-[#4c669a] hover:bg-primary hover:text-white transition-colors" href="#">
                <span class="material-symbols-outlined text-[18px]">share</span>
              </a>
              <a class="size-8 rounded-full bg-[#f8f9fc] flex items-center justify-center text-[#4c669a] hover:bg-primary hover:text-white transition-colors" href="#">
                <span class="material-symbols-outlined text-[18px]">mail</span>
              </a>
            </div>
          </div>
          <div>
            <h3 class="font-bold text-[#0d121b] mb-4">快速链接</h3>
            <ul class="space-y-2 text-sm text-[#4c669a]">
              <li><a class="hover:text-primary" href="https://zjt.hubei.gov.cn/" target="_blank">湖北省住建厅官网</a></li>
            </ul>
          </div>
          <div>
            <h3 class="font-bold text-[#0d121b] mb-4">联系方式</h3>
            <ul class="space-y-3 text-sm text-[#4c669a]">
              <li class="flex items-start gap-2">
                <span class="material-symbols-outlined text-[18px] mt-0.5">location_on</span>
                <span>武汉市汉阳区龙阳大道123号<br/>欧亚达汉阳国际广场A座1803</span>
              </li>
              <li class="flex items-center gap-2">
                <span class="material-symbols-outlined text-[18px]">call</span>
                <span>027-84881278 (电话)</span>
              </li>
              <li class="flex items-center gap-2">
                <span class="material-symbols-outlined text-[18px]">fax</span>
                <span>027-84881278 (传真)</span>
              </li>
              <li class="flex items-center gap-2">
                <span class="material-symbols-outlined text-[18px]">mail</span>
                <span>hbsjzlwxh@163.com</span>
              </li>
              <li class="flex items-center gap-2">
                <span class="material-symbols-outlined text-[18px]">markunread_mailbox</span>
                <span>430000</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="border-t border-[#e7ebf3] mt-8 pt-8 text-center text-xs text-[#9ca3af]">
          <p>©2018 湖北省建筑劳务协会保留所有权利。 | <a href="https://beian.miit.gov.cn/" target="_blank" class="hover:text-primary">鄂ICP备18023234号-1</a></p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';

export default {
  name: 'AssociationOverview',
  components: {
    AppHeader
  },
  data() {
    return {
      loading: true,
      imageLoadedMap: {},
      minioBase: 'https://www.hblaoxie.com/minio/laoxie/leaders/',
      leaders: [
        { id: '01', name: '王知兵', title: '会长、党支部书记', img: '01会长、党支部书记王知兵.jpg' },
        { id: '02', name: '闫桂奇', title: '秘书长、党支部副书记', img: '02秘书长、党支部副书记闫桂奇.jpg' },
        { id: '03', name: '刘春涛', title: '劳务总包专委会主任委员', img: '03刘春涛 劳务总包专委会主任委员.jpg' },
        { id: '04', name: '杨顺松', title: '副会长、钢筋专委会主任委员', img: '04杨顺松  副会长、钢筋专委会主任委员.jpg' },
        { id: '05', name: '盛德双', title: '副会长、木工专委会主任委员', img: '05盛德双 副会长、木工专委会主任委员.jpg' },
        { id: '06', name: '冯国兵', title: '副会长、泥工专委会主任委员', img: '06冯国兵 副会长、泥工专委会主任委员.jpg' },
        { id: '07', name: '刘兴祥', title: '副会长、孝感办事处主任委员', img: '07刘兴祥  副会长、孝感办事处主任委员.jpg' },
        { id: '08', name: '王锦章', title: '麻城办事处主任委员', img: '08王锦章  麻城办事处主任委员.png' },
        { id: '10', name: '邓燕青', title: '综合专委会主任委员', img: '10邓燕青 综合专委会主任委员.jpg' },
        { id: '14', name: '周家宏', title: '副会长、调解委主任、钢筋专委会副主任委员', img: '14周家宏 副会长 调解委主任  钢筋专委会副主任委员.jpg' },
        { id: '12', name: '张志铃', title: '监事长', img: '12张志铃 监事长.jpg' },
        { id: '13', name: '雷高华', title: '劳务总包专委会副主任委员', img: '13雷高华 劳务总包专委会副主任委员.jpg' },
        { id: '11', name: '仇宏贵', title: '对外联络部部长', img: '11仇宏贵 对外联络部部长.jpg' },
        { id: '15', name: '刘红乾', title: '木工专委会副主任委员', img: '15刘红乾 木工专委会副主任委员.jpg' },
        { id: '16', name: '刘启城', title: '泥工专委会副主任委员', img: '16刘启城 泥工专委会副主任委员.jpg' },
        { id: '17', name: '邓常国', title: '孝感办事处副主任委员', img: '17邓常国 孝感办事处副主任委员.jpg' },
        { id: '18', name: '郑德松', title: '麻城办事处副主任委员', img: '18郑德松 麻城办事处副主任委员.png' },
        { id: '19', name: '潘莉', title: '综合专委会副主任委员', img: '19潘莉 综合专委会副主任委员.jpg' },
        { id: '20', name: '肖猛', title: '调解委副主任', img: '20肖猛 调解委副主任.jpg' },
        { id: '21', name: '徐兴乔', title: '党支部组织委员', img: '21徐兴乔 党支部组织委员.jpg' }
      ]
    }
  },
  mounted() {
    // 模拟数据准备时间，显示骨架屏
    setTimeout(() => {
      this.loading = false;
    }, 600);
  },
  methods: {
    onImageLoad(id) {
      this.imageLoadedMap[id] = true;
    },
    scrollToSection(id) {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
    goToLogin() {
      this.$router.push('/login');
    },
    getLeaderPhoto(img) {
      if (!img) return '';
      return `${this.minioBase}${encodeURIComponent(img)}`;
    }
  }
}
</script>

<style scoped>
html {
  scroll-behavior: smooth;
}
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
